import {useGrpcRequest} from '@aboutyou/data-fetcher';
import {NavigationService_GetHomePageTakeoverLazy} from '@aboutyou/grpc-clients/tadarida/aysa_api/services/navigation/v1/service.grpc.lazy';
import {useSelectedTargetGroup} from '../../../shared-deprecated/useSelectedTargetGroup';
import {useGetHomepageTakeoverInMemoryCache} from './useGetHomepageTakeoverInMemoryCache/useGetHomepageTakeoverInMemoryCache';

/**
 * THIS HOOK IS ONLY TO BE USED ON MWEB
 * desktop is getting same information from getHeaderBulk request
 */
export const useGetHomepageTakeover = () => {
  const {targetGroup} = useSelectedTargetGroup();
  const {setCache, validateInMemoryData} =
    useGetHomepageTakeoverInMemoryCache();

  const request = useGrpcRequest(
    NavigationService_GetHomePageTakeoverLazy,
    {
      targetGroup,
    },
    {
      onServerSuccess: setCache,
      validateInMemoryCacheRequest: validateInMemoryData,
    },
  );

  return request;
};
